import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import styles from './styles.module.scss';
import { getBeneficioList, deleteVitrineBVById } from '../../services/api-auto';
import ModalLoading from '../../components/ModalLoading';
import BeneficioCard from '../../components/BeneficioCard';
import { useGetUser } from '../../hooks/useGetUser';
import { useDispatch } from "react-redux";
import { 
    showMsgW as showMsgWAction,
    showMsgE as showMsgEAction,
    showMsgS as showMsgSAction
} from '../../store/actions/snackbarActions.js';

const Vitrine = () => {

    const history = useHistory();
    const [beneficios, setBeneficios] = useState([])
    const [buscar, setBuscar] = useState('')
    const [verMais, setVerMais] = useState(true)
    const [modalLoading, setModalLoading] = useState(false);
    const [filter, setFilter] = useState( {page : 1, pageSize: 10, query: "" } );
    const dispatch = useDispatch();
    const showMsgE = (msg) => dispatch(showMsgEAction(msg));
    const showMsgS = (msg) => dispatch(showMsgSAction(msg));
    

    const getBeneficios = async() => {
        setModalLoading(true)
        const data = await getBeneficioList(filter);
        setModalLoading(false)
        setBeneficios(data.data)
    } 

    const deleteVitrine = async(id) => {
        setModalLoading(true)
        try {
            await deleteVitrineBVById(id);
            document.location.reload();
            showMsgS("Registro atualizado com sucesso");
            setModalLoading(false);
        }catch (e){
            showMsgE(e?.response?.data?.message);
            setModalLoading(false);
        }
        
    }

    useEffect(()=>{
        (beneficios && beneficios.items?.length > 0 && beneficios.page === beneficios.totalPages ) ? setVerMais(true) : setVerMais(false); 
        getBeneficios()
    },[])

    const addPage = async () => {
        setModalLoading(true)
        const data = await getBeneficioList(filter);
        setModalLoading(false)
        const f = filter;
        f.page += 1;
        setFilter(f);
        getBeneficios([...beneficios, ...data.data])
    }

    const findAcoes = async () => {
        const f = filter;
        f.query = buscar;
        f.page = 1;
        setFilter(f);
        const beneficio = await getBeneficioList(filter);
        getBeneficios(beneficio.data)
    }

    const user = useGetUser();

    return (
        <>
            {(user.perfilAcesso === 'Master') && (
                <div className={styles.wrapper}>
                    <div className={styles.title}>
                        Vitrine BV
                    </div>
                    <div className={styles.buttonWrapper}>
                        <button className={`btnInvert ${styles.btAdd}`} onClick={() => {history.push('/vitrine/detalhe')}}>
                            + CADASTRAR BENEFICIO
                        </button>
                    </div>
                    <div className={styles.subTitle}>
                        Benefícios cadastrados
                    </div>
                    <div className={styles.buscar}>
                        <FormControl>
                            <TextField  type="text"  size="small"
                                onChange={(e) => {setBuscar(e.target.value)}}
                                label="Faça sua busca"
                                value={buscar}
                                variant="filled"
                                className="customFilledInput"
                                onKeyDown= {
                                    (e) => {
                                        if (e.key === 'Enter') {
                                            findAcoes();
                                            e.preventDefault();
                                        }
                                    }
                                }
                                InputProps={{endAdornment: (
                                    <button onClick={findAcoes} className={styles.searcButton}>
                                        <FontAwesomeIcon icon={faSearch}/>
                                    </button>
                                )}}
                            />
                        </FormControl>
                    </div>
                    <div className={styles.acoesWrapper}>
                        {beneficios && beneficios.items?.map(
                            (b) => <BeneficioCard beneficio={b} actionDelete={deleteVitrine}/>
                        )}
                    </div>
                    { verMais && (
                        <div className={styles.verMaisWrapper}>
                            <button className={`customButton ${styles.verMaisButton}`} onClick={addPage} >
                                Ver mais
                            </button>
                        </div>
                    )}
                    <ModalLoading
                        open={modalLoading} 
                        size="lg"
                    />
                </div>
                
            )}
        </>
    );
  
}

export default Vitrine;